import { render, staticRenderFns } from "./welcome-integrations.vue?vue&type=template&id=a35f3b3e&scoped=true&"
import script from "./welcome-integrations.vue?vue&type=script&lang=js&"
export * from "./welcome-integrations.vue?vue&type=script&lang=js&"
import style0 from "./welcome-integrations.vue?vue&type=style&index=0&id=a35f3b3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35f3b3e",
  null
  
)

export default component.exports